export default class DataList {
    constructor() {
        this.listFilter = document.querySelector('.js-list-filter');
        this.list = document.querySelector('.js-list');
        this.regionDropdownOptions = document.querySelector('.js-region-options');
        this.regionInput = document.querySelector('#region-input');
        this.currentRegion = '';
        this.noResults = this.ensureNoResultsAlert();
        this.bindFilterKeyEvents();
        this.bindRegionDropdownEvents();
        this.updateNoResultsVisibility();
    }

    bindFilterKeyEvents() {
        this.listFilter.addEventListener('keyup', (e) => {
            this.filterItems(e.currentTarget.value.toLowerCase(), this.currentRegion);
        });
    }

    bindRegionDropdownEvents() {
        this.regionDropdownOptions.addEventListener('click', () => {
            this.currentRegion = this.regionInput.value;
            this.filterItems(this.listFilter.value.toLowerCase(), this.currentRegion);
        });
    }

    filterItems(value, region) {
        const items = this.list.querySelectorAll('li');
        items.forEach(item => {
            const text = item.textContent.toLowerCase();
            const itemRegion = item.getAttribute('data-region');
            const matchesText = text.includes(value);
            const matchesRegion = region === '' || itemRegion === region;
            item.style.display = matchesText && matchesRegion ? '' : 'none';
        });
        this.updateNoResultsVisibility();
    }

    ensureNoResultsAlert() {
        let box = document.querySelector('.js-no-results');
        if (!box) {
            box = document.createElement('div');
            box.className = 'js-no-results alert alert--info';
            box.setAttribute('role', 'status');
            box.setAttribute('aria-live', 'polite');
            box.style.display = 'none';
            box.innerHTML = `
                <div class="alert__icon">
                    <i class="fa fa-circle-exclamation"></i>
                </div>
                <div class="alert__header">
                    Den by, du indtaster, har ikke en brandstation, som søger folk lige nu. Du kan skrive dig op på venteliste ved at klikke <a href="/venteliste">her</a> eller finde "Venteliste" i menuen.
                </div>
            `;
            this.list.insertAdjacentElement('afterend', box);
        }
        return box;
    }

    updateNoResultsVisibility() {
        const items = this.list.querySelectorAll('li');
        const hasVisible = Array.from(items).some(li => li.style.display !== 'none');
        this.noResults.style.display = hasVisible ? 'none' : '';
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new DataList();
});
